var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hot-box-title",style:(_vm.styleCss)},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"Underline"})]),(_vm.title2)?_c('div',{staticClass:"more",on:{"click":_vm.more}},[_vm._v(_vm._s(_vm.title2))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }